import { GridLoader } from "react-spinners";

const LoadingSpinner = () => {
  return <GridLoader color="#b3b3b3" />;
};

export default LoadingSpinner;
